<template>
  <el-dialog
    title="批量删除"
    :visible="visible"
    width="850px"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <multiple-input
      v-model="ids"
      type="textarea"
      :rows="5"
      formatter="number"
      :placeholder="ph"
    ></multiple-input>

    <div slot="footer" style="margin-top:30px">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确认提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MultipleInput from '@/components/MultipleInput'

import {
  TASK_TYPE_ENUM,
  BUSS_TYPE_ENUM,
  bussTypeMap
} from '../const'

export default {
  name: 'BatchDeleteDialog',
  components: {
    MultipleInput
  },
  props: {
    visible: Boolean,
    mode: {
      type: Number,
      default: TASK_TYPE_ENUM.COMPLAINT
    },
    bussType: {
      type: Number,
      default: BUSS_TYPE_ENUM.COMPLAINT
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      TASK_TYPE_ENUM,
      bussTypeMap,

      ids: []
    }
  },
  computed: {
    ph() {
      return this.mode === TASK_TYPE_ENUM.SONGLIST
        ? `请输入需要删除的${bussTypeMap[this.bussType]}歌单ID`
        : '请输入需要删除的匹配结果ID'
    },
  },
  methods: {
    handleClose() {
      if (this.loading) {
        this.$message.warning('批量删除中，请稍等！')
        return
      }
      this.ids = []
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      if (this.ids.length === 0) {
        this.$message.warning('请输入至少一个ID')
        return
      }
      this.$emit('submit', [...this.ids])
    }
  }
}
</script>
